import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import colors from '../../../../themes/main-colors';

interface CustomIconProps extends Omit<SvgIconProps, 'color'> {
  color?: string;
}

const HomePinIcon: React.FC<CustomIconProps> = ({
  color = colors.black,
  ...props
}) => {
  const shadow = 'drop-shadow(0px 0px 5px rgba(0,0,0,0.5))';

  return (
    <SvgIcon {...props} viewBox="0 0 26 32" style={{ filter: shadow }}>
      <path
        d="M13.0002 32C8.70686 28.3467 5.5002 24.9533 3.3802 21.82C1.2602 18.6867 0.200195 15.7867 0.200195 13.12C0.200195 9.12 1.48686 5.93333 4.0602 3.56C6.63353 1.18667 9.61353 0 13.0002 0C16.3869 0 19.3669 1.18667 21.9402 3.56C24.5135 5.93333 25.8002 9.12 25.8002 13.12C25.8002 15.7867 24.7402 18.6867 22.6202 21.82C20.5002 24.9533 17.2935 28.3467 13.0002 32Z"
        fill={color}
      />
      <path
        d="M8 18H10.941V13.1016H15.059V18H18V10.1627L13 7L8 10.1627V18Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default HomePinIcon;
